export const UserRoles = {
  superAdmin: 'SuperAdmin',
  admin: 'Admin',
  cohealer: 'Cohealer',
  cohealerAssistant: 'CohealerAssistant',
  client: 'Client',
};
